import { createTheme } from '@material-ui/core';

let theme = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 1130, lg: 1240, xl: 1940 } },
})

theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Plus Jakarta Sans !important',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius:"16px"
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor:"rgba(0,0,0,0.75)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight:"174px",
          minWidth:"963px",
          borderRadius:"32px !important",
          fontFamily: 'Plus Jakarta Sans !important',
          fontSize:"50px",
          fontWeight:"600",
          textTransform:"unset",
          boxShadow: "0px 10px 15px #BFDBFE",
          "&:hover": {
            backgroundColor: "#174EA6",
            boxShadow: "0px 10px 15px #BFDBFE",
          },
          '&.Mui-disabled': {
            color: "#EEEEEE",
            backgroundColor: "#D3D3D3",
            "img" : {
              opacity:0.6,
            }
          }
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Plus Jakarta Sans !important',
          borderRadius:"24px !important",
          background:"#F3F3F6",
          height:'180px',
          minHeight:'180px',
          paddingLeft:"40px",
          paddingRight:"40px",
          fontSize:"50px",
          color:"black",
          "input" : {
            textTransform:"capitalize",
            textAlign:"center",
          },
          "fieldset" : {
            border:"4px solid #174EA6 !important",
          },
          "&:hover fieldset": {
            border:"4px solid #174EA6 !important",
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: '#111125', //black
      paper: '#F9F9FC' //light grey
    },
    primary: {
      contrast: '#174EA6', //blue-violet
      main: '#4285F4' //blue
    },
    text: {
      primary: '#1E293B', //black
      secondary: '#174EA6' //blue-violet
    }
  },
  shadows: [
    'none',
    '0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
  ],
  typography: {
    h1: {
      fontWeight: 500,
      fontSize: 35,
      letterSpacing: '-0.24px'
    },
    h2: {
      fontWeight: 500,
      fontSize: 29,
      letterSpacing: '-0.24px'
    },
    h3: {
      fontWeight: 500,
      fontSize: 24,
      letterSpacing: '-0.06px'
    },
    h4: {
      fontWeight: 500,
      fontSize: 20,
      letterSpacing: '-0.06px'
    },
    h5: {
      fontWeight: 500,
      fontSize: 16,
      letterSpacing: '-0.05px'
    },
    h6: {
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: '-0.05px'
    },
    overline: {
      fontWeight: 500
    }
  }
});

export default theme;
